import { render } from "./Chart.vue?vue&type=template&id=56b26153&scoped=true&ts=true"
import script from "./Chart.vue?vue&type=script&lang=ts"
export * from "./Chart.vue?vue&type=script&lang=ts"

import "./Chart.vue?vue&type=style&index=0&id=56b26153&scoped=true&lang=css"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56b26153"]])

export default __exports__